export default __webpack_public_path__ + "static/media/Group8889.6620ec97.svg";